var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper h-100"},[_c('navbar'),_vm._v(" "),_c('div',{staticClass:"container-fluid h-100"},[_c('div',{staticClass:"row h-100"},[(_vm.user)?_c('sidebar'):_vm._e(),_vm._v(" "),_c('child')],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39b3dbb4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/layouts/default.vue
// module id = null
// module chunks = 